import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import selectors from '@/ui/flux/selectors';

function useIsEnabledAsset(name: string) {
  const enabledSelector = useMemo(
    () => selectors.enabledAssets.createIsEnabled(name),
    [name],
  );
  return useSelector<unknown, boolean>(enabledSelector);
}

export default useIsEnabledAsset;
